module.exports = __webpack_public_path__ + "img/chart.dace35cc.svg";